module.exports = __webpack_public_path__ + "media/images/flags/4x3/hti-6b88c7d2819c6edc17ca23683766a682.svg";